<template>
    <div class="flag-selector-container">
        <transition name="fade-page">
        <div v-show="!drawer" class="main-content">
            <div class="header">
            <h1 class="main-title">
                <span class="highlight-text">2026</span> 你希望自己...
            </h1>
            <p class="sub-title">（最多选择3个核心目标）</p>
            </div>

            <div class="goals-scroll-container">
            <div class="goal-row" v-for="(row, rowIndex) in goalRows" :key="rowIndex">
                <div class="goal-wrapper" :style="getAnimationStyle(rowIndex)">
                <div class="goal-pill" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}`"
                    :class="{ 'is-selected': isSelected(goal.id) }" @click="toggleGoal(goal.id)">
                    <span class="goal-emoji">{{ goal.emoji }}</span>
                    <span class="goal-text">{{ goal.text }}</span>
                    <transition name="bounce">
                    <div class="check-mark" v-if="isSelected(goal.id)">✓</div>
                    </transition>
                </div>
                <div class="goal-pill duplicate" v-for="(goal, index) in row.goals" :key="`${rowIndex}-${index}-copy`"
                    :class="{ 'is-selected': isSelected(goal.id) }" @click="toggleGoal(goal.id)">
                    <span class="goal-emoji">{{ goal.emoji }}</span>
                    <span class="goal-text">{{ goal.text }}</span>
                    <transition name="bounce">
                        <div class="check-mark" v-if="isSelected(goal.id)">✓</div>
                    </transition>
                </div>
                </div>
            </div>
            </div>

            <div class="footer-actions">
            <button class="theme-btn secondary-btn" :disabled="selectedGoals.length === 0" @click="confirmSelection">
                开启学习计划
            </button>
            <!-- <button class="theme-btn secondary-btn" @click="openDrawer">
                定制我的形象
            </button> -->
            </div>
        </div>
        </transition>

        <footer v-show="ReportData.eduRecom" class="footer-hint fade-in">
            <div class="swipe-guide">
                <span class="arrow">‹</span>
                <span>左滑查看学历提升</span>
            </div>
        </footer>
        <transition name="slide-up">
        <div class="drawer-overlay" v-if="drawer" @click.self="drawer = false">
            <div class="drawer-container">
            <div class="drawer-header">
                <h2 class="drawer-title">我的 2026 形象</h2>
                <span class="close-icon" @click="drawer = false">✕</span>
            </div>

            <div class="poster-card">
                <div class="avatar-preview-window">
                    <transition name="fade-scale" mode="out-in">
                        <img v-if="selectedAvatarImgUrl" :src="selectedAvatarImgUrl" class="main-avatar-img" :key="selectedAvatarId">
                    </transition>
                    
                    <!-- <div class="stats-badge glass-style">

                        <div class="badge-content">
                            <div class="lab-name">{{ ReportData.lab }}</div>
                            <div class="lab-value">{{ ReportData.plansLab }}</div>
                        </div>
                    </div> -->
                </div>
                <div class="avatar-selector-wrapper">
                    <p class="selector-label">选择喜欢的形象：</p>
                    <div class="avatar-grid-layout">
                        <div v-for="item in currentGenderAvatars" :key="item.id" class="grid-item" :class="{ 'active': selectedAvatarId === item.id }"  @click="selectAvatar(item.id)">
                            <img :src="item.imgUrl" alt="avatar option">
                            <div class="selected-badge" v-if="selectedAvatarId === item.id">
                                <!-- <span class="check-icon">L</span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="drawer-footer-hint">
                已自动保存你的形象设置
            </div> -->
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object,  required: true}
  },
    data() {
        return {
        drawer: false,
        selectedGoals: [],
        selectedAvatarId: null,
        goalRows: [
            {
                goals: [
                    { id: '1', emoji: '💡', text: '岗位专精 → 成为本岗位专家' },
                    { id: '2', emoji: '🎤', text: '过程优化 → 提升工作效率和质量' },
                    { id: '3', emoji: '🤝', text: '方法论掌握 → 系统化解决问题能力' },
                ]
            },
            {
                goals: [
                    { id: '4', emoji: '🌟', text: '行业前沿 → 跟踪最新技术与趋势' },
                    { id: '5', emoji: '🤖', text: '跨界探索 → 尝试跨部门/跨领域工作' },
                    { id: '6', emoji: '📱', text: '问题攻坚 → 提高复杂问题解决能力' }
                ]
            },
            {
                goals: [
                    { id: '7', emoji: '📅', text: '数字化能力 → 掌握数字化工具和方法' },
                    { id: '8', emoji: '📈', text: '沟通协调 → 更有效地与他人沟通' },
                    { id: '9', emoji: '🏭', text: '跨部门协作 → 学会多部门协调合作' },
                ]
            },
            {
                goals: [
                    { id: '10', emoji: '🔍', text: '影响力提升 → 增强个人在组织内的影响力' },
                    { id: '11', emoji: '🛠️', text: '变革推动 → 带动组织变革和创新' },
                    { id: '12', emoji: '🔧', text: '软实力提升 → 提升表达、谈判、沟通能力' }
                ]
            },
            {
                goals: [
                    { id: '13', emoji: '💖', text: '人际网络 → 扩展职业与社交关系' },
                    { id: '14', emoji: '🗺️', text: '心智升级 → 学会思维升级与复盘反思' },
                    { id: '15', emoji: '🧘‍♀️', text: '抗压适应 → 更好应对压力与变化' }
                ]
            },
        ],
        imgItem: [
            { id: 1, imgUrl: require('../../assets/25Year/组合A.png') },
            { id: 2, imgUrl: require('../../assets/25Year/组合B.png') },
            { id: 3, imgUrl: require('../../assets/25Year/组合C.png') },
            { id: 4, imgUrl: require('../../assets/25Year/组合D.png') },
            { id: 5, imgUrl: require('../../assets/25Year/组合E.png') },
            { id: 6, imgUrl: require('../../assets/25Year/组合F.png') },
            { id: 7, imgUrl: require('../../assets/25Year/组合G.png') }
        ],
        imgItem1: [
            { id: 'm1', imgUrl: require('../../assets/25Year/组合男1.png') },
            { id: 'm2', imgUrl: require('../../assets/25Year/组合男2.png') },
            { id: 'm3', imgUrl: require('../../assets/25Year/组合男4.png') },
            { id: 'm4', imgUrl: require('../../assets/25Year/组合男5.png') },
            { id: 'm5', imgUrl: require('../../assets/25Year/组合男6.png') },
            { id: 'm6', imgUrl: require('../../assets/25Year/组合男7.png') },
            { id: 'm7', imgUrl: require('../../assets/25Year/组合男8.png') },
            { id: 'm8', imgUrl: require('../../assets/25Year/组合男9.png') },
            // { id: 'm9', imgUrl: require('../../assets/25Year/组合男10.png') },
        ],
        };
    },
    computed: {
        currentGenderAvatars() {
            // 强制转为字符串，防止后端返回数字导致匹配失败
            const gender = String(this.ReportData.gender); 

            switch (gender) {
                case '77': // 男
                    return this.imgItem1;
                case '70': // 女
                    return this.imgItem;
                case '88': // 保密
                    // 如果保密有专属图库就换掉，否则通常默认指向女库或通用库
                    return this.imgItem; 
                default:
                    return this.imgItem; // 默认兜底
            }
        },
        selectedAvatarImgUrl() {
            if (!this.selectedAvatarId) return null;
            const avatarObj = this.currentGenderAvatars.find(item => item.id === this.selectedAvatarId);
            return avatarObj ? avatarObj.imgUrl : '';
        }
    },
    methods: {
        selectAvatar(id) {
            this.selectedAvatarId = id;
        },
        initDefaultAvatar() {
            if (this.currentGenderAvatars.length > 0) {
                this.selectedAvatarId = this.currentGenderAvatars[0].id;
            }
        },
        openDrawer() {
            this.drawer = true;
            if (!this.selectedAvatarId) {
                this.initDefaultAvatar();
            }
        },
        toggleGoal(goalId) {
        const index = this.selectedGoals.indexOf(goalId);
        if (index === -1) {
            if (this.selectedGoals.length < 3) {
            this.selectedGoals.push(goalId);
            } else {
            if (this.$message) this.$message.warning('建议聚焦 3 个核心目标哦！');
            }
        } else {
            this.selectedGoals.splice(index, 1);
        }
        },
        isSelected(goalId) {
        return this.selectedGoals.includes(goalId);
        },
        confirmSelection() {
        if (this.selectedGoals.length === 0) return;
        const selectedGoalTexts = this.selectedGoals.map(goalId => {
            for (const row of this.goalRows) {
            const foundGoal = row.goals.find(goal => goal.id === goalId);
            if (foundGoal) return foundGoal.text;
            }
            return null;
        }).filter(text => text);

        this.$emit('confirmSelection', { comment: selectedGoalTexts.join(', '), avatarId: this.selectedAvatarId });
        },
        getAnimationStyle(rowIndex) {
        const duration = 35 + rowIndex * 2;
        const direction = rowIndex % 2 === 0 ? 'normal' : 'reverse';
        return { animationDuration: `${duration}s`, animationDirection: direction };
        }
    },
    mounted() {
        this.initDefaultAvatar();
    }
};
</script>

<style scoped>
/* --- 基础变量 --- */
:root {
  --primary-color: #6A3D9A;
  --accent-color: #FFD700;
  --drawer-bg: #ffffff;
}

.flag-selector-container {
    background: 
            url("../../assets/26April/logo.png") right top no-repeat,
            url("../../assets/26April/bg.jpg") no-repeat;
        background-size: 100% 100%, cover;
    width: 100%;
    min-height: 100vh;
    overflow: hidden;
    position: relative;
}

/* --- 目标选择器样式 (保持原样) --- */
.header { text-align: center; padding-top: 8vh; margin-bottom: 4vh; }
.main-title { font-size: 28px; color: #fff; font-weight: 800; }
.highlight-text { background: linear-gradient(45deg, #fff, #fff); -webkit-background-clip: text; -webkit-text-fill-color: transparent; font-size: 36px; }
.sub-title { font-size: 14px; color: #fff; }
.goals-scroll-container { width: 100%; overflow: hidden; padding: 20px 0; }
.goal-row { display: flex; margin-bottom: 20px; height: 50px; align-items: center; }
.goal-wrapper { display: flex; width: max-content; animation: scrollGoals linear infinite; }
.goal-pill { background: rgba(255,255,255,0.9); border-radius: 30px; padding: 10px 20px; margin: 0 10px; display: flex; align-items: center; cursor: pointer; box-shadow: 0 4px 12px rgba(106,61,154,0.1); transition: all 0.3s; white-space: nowrap; border: 2px solid transparent; }
.goal-pill.is-selected { border-color: var(--accent-color); background: #f0f4ff; }
.footer-actions { display: flex; justify-content: center; gap: 20px; }
.theme-btn { border: none; border-radius: 50px; padding: 12px 30px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.3s; }
.primary-btn { background: var(--primary-color); color: white; }
.secondary-btn { background: white; color: var(--primary-color); border: 2px solid var(--primary-color); }

/* --- 抽屉与新头像选择器 --- */
.drawer-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 2000;
  background-color: rgba(0, 0, 0, 0.5); backdrop-filter: blur(5px);
  display: flex; justify-content: center; align-items: flex-end;
}

.drawer-container {
  width: 100%; max-width: 500px; background-color: #fcfaf2; border-radius: 24px 24px 0 0;
  padding: 20px; max-height: 85vh; display: flex; flex-direction: column;
}

.drawer-header { display: flex; justify-content: space-between; margin-bottom: 15px; align-items: center; }
.drawer-title { font-size: 20px; color: var(--primary-color); margin: 0; font-weight: bold; }
.close-icon { font-size: 20px; color: #999; cursor: pointer; }

/* 预览窗 */
.drawer-container {
    max-height: 90vh; /* 稍微增加高度以容纳更多平铺内容 */
}

.avatar-preview-window {
    height: 240px; /* 稍微压缩预览窗口，给下方的平铺列表留出更多空间 */
}
/* --- 修改后的形象选择器样式 --- */
.avatar-selector-wrapper {
    margin-top: 15px;
    flex: 1; /* 让它占满剩余空间 */
    overflow-y: auto; /* 如果头像太多，允许垂直滚动 */
}

.main-avatar-img {
    height: 95%;      /* 稍微放大一点，占满高度 */
    width: auto;      /* 宽度自动 */
    display: block;   /* 消除行内元素间隙 */
    object-fit: contain; 
    margin: 0 auto;   /* 再次确保居中 */
    filter: drop-shadow(0 5px 15px rgba(0,0,0,0.1));
}

.avatar-grid-layout {
    display: grid;
    /* 每行显示 4 个，间距 12px */
    grid-template-columns: repeat(4, 1fr); 
    gap: 12px;
    padding: 10px 5px;
}

.grid-item {
    aspect-ratio: 1 / 1; /* 保持正方形 */
    border-radius: 12px;
    background: #fff;
    border: 2px solid transparent;
    position: relative;
    transition: all 0.2s ease;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    overflow: hidden;
}

.grid-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* 选中态样式 */
.grid-item.active {
    border-color: var(--primary-color);
    background: #f0ebf7;
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(106, 61, 154, 0.15);
}

/* 选中勾选标记 */
.selected-badge {
    position: absolute;
    top: 0;
    right: 0;
    background: var(--primary-color);
    width: 18px;
    height: 18px;
    border-bottom-left-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.check-icon {
    color: white;
    font-size: 10px;
    transform: rotate(45deg) scaleX(-1); /* 简单画一个勾 */
    border-bottom: 2px solid #fff;
    border-right: 2px solid #fff;
    width: 4px;
    height: 8px;
    margin-bottom: 2px;
}
/* --- 底部引导 --- */
.footer-hint {
    text-align: center;
    margin-top: auto;
    padding-top: 10px;
}

.footer-hint p {
    font-size: 15px;
    color: var(--text-light);
    opacity: 0.8;
    margin-bottom: 14px;
    font-weight: 500;
}

.swipe-guide {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 16px;
    color: var(--text-light);
    font-weight: 500;
    animation: moveLeft 1.5s infinite ease-in-out;
}

.swipe-guide .arrow {
    font-size: 20px;
    color: var(--accent-cyan);
}

/* 适配小屏幕，如果是超小屏幕改回每行3个 */
@media screen and (min-width: 786px) {
    .avatar-grid-layout {
        grid-template-columns: repeat(3, 1fr);
    }
    .flag-selector-container { background-image: url("../../assets/26April/pcbg.jpg"); }
}

/* 动画 */
@keyframes scrollGoals { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
.slide-up-enter-active, .slide-up-leave-active { transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1); }
.slide-up-enter, .slide-up-leave-to { transform: translateY(100%); }
.fade-scale-enter-active, .fade-scale-leave-active { transition: all 0.3s; }
.fade-scale-enter { opacity: 0; transform: scale(0.9); }
.fade-scale-leave-to { opacity: 0; transform: scale(1.1); }
@keyframes moveLeft {
    0%, 100% { transform: translateX(0); opacity: 0.7; }
    50% { transform: translateX(-12px); opacity: 1; }
}
</style>